import i18next, { i18n } from "i18next"

import {
  StripeBillingPortalSessionRequest,
  StripeCheckoutSessionRequest,
  StripeSessionResponse,
} from "@treefort/api-spec"
import { DisplayableError } from "@treefort/lib/displayable-error"

import api from "./api"
import { checkoutSessionManager } from "./checkout/session"
import { getTreefortMessageFromError } from "./get-treefort-message-from-error"
import { logError } from "./logging"
import openUrl from "./open-url"

export async function openStripeCheckout({
  subscriptionPlanId,
  promoCode,
}: {
  subscriptionPlanId: number
  promoCode?: string
}): Promise<void> {
  try {
    const data: StripeCheckoutSessionRequest = {
      subscriptionPlanId,
      promoCode,
      locale: i18next.language,
    }
    const res = await api.post<StripeSessionResponse>(
      "/integrations/stripe/checkout-session",
      data,
    )
    await openUrl(res.data.sessionUrl, {
      openInApp: true,
      parentalGateway: false,
    })
  } catch (error) {
    await checkoutSessionManager.endSession({ complete: false })
    logError(new DisplayableError(getTreefortMessageFromError(error), error))
  }
}

export async function openStripeBillingPortal({
  i18n,
}: {
  i18n: i18n
}): Promise<void> {
  try {
    const data: StripeBillingPortalSessionRequest = {
      locale: i18n.language,
    }
    const res = await api.post<StripeSessionResponse>(
      "/integrations/stripe/billing-portal-session",
      data,
    )
    await openUrl(res.data.sessionUrl, {
      openInApp: true,
      parentalGateway: false,
    })
  } catch (error) {
    logError(
      new DisplayableError(
        i18n.t("An error occurred. Please try again."),
        error,
      ),
    )
  }
}
